<!--
 * @Author: rossdong rossdong@yntengyun.com
 * @Date: 2026-03-18
 * @LastEditors: rossdong rossdong@yntengyun.com
 * @LastEditTime: 2026-03-30 17:38:51
 * @FilePath: /Mobile/src/pages/complaint/views/visual/disposalAnalysis/comps/FirstPointAreaCell.vue
 * @Description: 处置情况分析-第一落点分布
 *
-->
<template>
  <div class="w-full flex flex-col">
    <div class="w-full flex items-end justify-between my-16">
      <div class="text-16 font-bold text-black-primary">第一落点分布</div>
      <!-- <div class="flex items-center" @click="ruleDialogShow = true">
        <img src="@/assets/complaint/ic_info_tips.png" alt="" class="size-14 mr-3">
        <span>统计说明</span>
      </div> -->
    </div>

    <div class="card flex flex-col" v-if="!tableMode">
      <div v-if="loading" class="state-text">
        加载中...
      </div>
      <div v-else-if="!list.length" class="state-text">暂无数据</div>
      <template v-else>
        <div ref="chartEl" class="chart"></div>
        <div class="legend-wrap">
          <div class="legend-grid">
            <div class="legend-item" v-for="(item, idx) in displayList" :key="idx">
              <div class="legend-line1">
                <i class="dot" :style="{ background: item.color }"></i>
                <span class="legend-total">{{ item.label }}</span>
                <span class="legend-total">{{ item.total }}件</span>
              </div>
              <div class="legend-line2">
                <span>占比</span>
                <span>{{ item.ratio || "0%" }}</span>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>

    <div v-else class="card flex flex-col px-10 pt-10 pb-20">
      <o-table :columns="tableColumns" :data="tableData" :height="330" />
    </div>

    <div class="w-full flex justify-center items-center mb-13" @click="tableMode = !tableMode">
      <img src="@/assets/complaint/ic_exchange.png" class="size-12 mr-4">
      <span v-if="tableMode" class="text-[#229F60]">切换为图表</span>
      <span v-else class="text-[#229F60]">切换为表格</span>
    </div>

    <TipsDialog v-model="ruleDialogShow" title="统计说明" :content="ruleText" confirmButtonText="关闭" />
  </div>
</template>

<script>
import echarts from "echarts";
import APIS from "@/service/modules/complaintApis/modules/visualization.js";
import { Table } from "@/components/Table";
import TipsDialog from "../../comps/TipsDialog.vue";
import visualFilterMixin from "../../mixins/visualFilterMixin";

export default {
  name: "FirstPointAreaCell",
  mixins: [visualFilterMixin],
  components: {
    "o-table": Table,
    TipsDialog,
  },
  props: {
    county: { type: String, default: "" }
  },
  data() {
    return {
      chart: null,
      _onResize: null,
      loading: false,
      tableMode: false,
      ruleDialogShow: false,

      total: 0,
      list: [],
      colors: ["#36B374", "#4083E7", "#FF8C19", "#7C89FF"],

      tableColumns: [
        { title: "排序", dataProp: "sort", minWidth: "60px", fixed: "left" },
        { title: "类型", dataProp: "label", minWidth: "110px", fixed: "left" },
        {
          title: "数量", dataProp: "total", minWidth: "90px", renderCell(h, { rowData }) {
            return h("div", `${rowData.total}件`);
          }
        },
        { title: "占比", dataProp: "ratio", minWidth: "90px" },
      ],

      ruleText: ''
    };
  },
  computed: {
    displayList() {
      return (this.list || []).map((item, idx) => ({
        ...item,
        color: this.colors[idx % this.colors.length]
      }));
    },
    tableData() {
      return (this.displayList || []).map((item, idx) => ({
        ...item,
        sort: idx + 1
      }));
    }
  },
  watch: {
    list: {
      deep: true,
      handler() {
        this.$nextTick(() => this.renderChart());
      }
    },
    tableMode(val) {
      if (val) {
        this.disposeChart();
        return;
      }
      this.$nextTick(() => {
        this.ensureChart();
        this.renderChart();
      });
    }
  },
  methods: {
    ensureChart() {
      const el = this.$refs.chartEl;
      if (!el) return;
      if (this.chart) {
        if (typeof this.chart.getDom === "function" && this.chart.getDom() !== el) {
          this.disposeChart();
        } else {
          return;
        }
      }
      this.chart = echarts.init(el);
      this._onResize = () => {
        if (this.chart) this.chart.resize();
      };
      window.addEventListener("resize", this._onResize, { passive: true });
    },
    disposeChart() {
      if (this._onResize) {
        window.removeEventListener("resize", this._onResize);
        this._onResize = null;
      }
      if (this.chart) {
        this.chart.dispose();
        this.chart = null;
      }
    },
    buildOption() {
      const pieData = (this.displayList || []).map(item => ({
        name: item.label || "-",
        value: Number(item.total || 0),
        itemStyle: { color: item.color },
        ratio: item.ratio || "0%",
      }));

      return {
        tooltip: {
          trigger: "item",
          formatter: (p) => {
            const row = (this.displayList || []).find(i => i.label === p.name) || {};
            return `${p.name}<br/>数量：${row.total || 0}件<br/>占比：${row.ratio || "0%"}`;
          }
        },
        series: [
          {
            type: "pie",
            radius: ['50%', '90%'],
            center: ["50%", "48%"],
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: true,
                position: "inside",
                color: "#fff",
                fontSize: 14,
                fontWeight: 500,
                formatter: (p) => (p.data && p.data.ratio) || "0%"
              },
              emphasis: {
                show: true,
                position: "inside",
                color: "#fff",
                fontSize: 14,
                fontWeight: 500,
                formatter: (p) => (p.data && p.data.ratio) || "0%"
              }
            },
            labelLine: { show: false },
            itemStyle: {
              borderColor: "#fff",
              borderWidth: 3
            },
            data: pieData
          }
        ],
        graphic: [
          {
            type: "group",
            left: "center",
            top: "43%",
            children: [
              {
                type: "text",
                style: {
                  text: `${this.total}`,
                  fill: "#1E2226",
                  fontSize: 24,
                  fontWeight: 700,
                  textAlign: "center"
                },
                top: 8
              },
              {
                type: "text",
                style: {
                  text: "件",
                  fill: "#666",
                  fontSize: 14,
                  fontWeight: 500,
                  textAlign: "center"
                },
                top: 36
              },

            ]
          }
        ]
      };
    },
    renderChart() {
      if (this.loading || !this.list.length) return;
      this.$nextTick(() => {
        this.ensureChart();
        if (!this.chart) return;
        this.chart.setOption(this.buildOption(), true);
        this.chart.resize();
      });
    },
    onLoad() {
      const { areaId, beginTime, endTime, rule, channel } = this.filterParams;
      const params = {
        cityId: areaId,
        county: this.county,
        startDate: beginTime,
        endDate: endTime,
        rule: rule,
        channel: channel,
      };

      this.loading = true;
      return APIS.firstPointCount(params).then((res) => {
        if (!res || res.ret !== 0) {
          this.total = 0;
          this.list = [];
          return;
        }
        const data = res.data || {};
        this.total = Number(data.total || 0);
        this.list = Array.isArray(data.list) ? data.list : [];
      }).finally(() => {
        this.loading = false;
        this.$nextTick(() => this.renderChart());
      });
    }
  },
  mounted() {
    this.ensureChart();
  },
  beforeDestroy() {
    this.disposeChart();
  }
};
</script>

<style lang="less" scoped>
.card {
  margin-bottom: 13px;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.04);
  padding: 12px;
}

.chart {
  width: 100%;
  height: 239px;
}

.legend-wrap {
  margin: 4px 10px 6px;
}

.legend-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 14px 12px;
}

.legend-item {
  width: calc(50% - 6px);
  min-width: 0;
}

.legend-line1 {
  display: flex;
  align-items: center;
  gap: 8px;
}

.dot {
  width: 12px;
  height: 12px;
  border-radius: 999px;
  flex-shrink: 0;
}

.legend-name {
  font-size: 16px;
  line-height: 22px;
  color: #1E2226;
  white-space: nowrap;
}

.legend-total {
  font-size: 14px;
  line-height: 20px;
  color: #1E2226;
  font-weight: 600;
  white-space: nowrap;
}

.legend-line2 {
  margin-left: 20px;
  margin-top: 4px;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #666;
  font-size: 14px;
  line-height: 20px;
}



.state-text {
  width: 100%;
  height: 240px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 14px;
}
</style>
